//#region src/utils/formatters.ts
var e = "es-AR";
function t(t, n = "ARS", r = {}) {
	let { compact: i = !1, showCode: a = !0 } = r;
	try {
		return i ? new Intl.NumberFormat(e, {
			style: "currency",
			currency: n,
			currencyDisplay: a ? "code" : "symbol",
			notation: "compact",
			compactDisplay: "short"
		}).format(t) : new Intl.NumberFormat(e, {
			style: "currency",
			currency: n,
			currencyDisplay: a ? "code" : "symbol",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}).format(t);
	} catch (e) {
		return console.error(`Failed to format currency: ${n}`, e), `${a ? `${n} ` : "$"}${t.toFixed(2)}`;
	}
}
function n(e, n = "ARS") {
	return t(e, n, { compact: !0 });
}
function r(t, n = 2) {
	return new Intl.NumberFormat(e, {
		minimumFractionDigits: n,
		maximumFractionDigits: n
	}).format(t);
}
function i(t, n = 2) {
	return new Intl.NumberFormat(e, {
		style: "percent",
		minimumFractionDigits: n,
		maximumFractionDigits: n
	}).format(t);
}
function a(t, n = {}) {
	let { style: r = "medium", showTime: i = !1 } = n, a = typeof t == "string" ? new Date(t) : t, o = { dateStyle: {
		short: "short",
		medium: "medium",
		long: "long"
	}[r] };
	return i && (o.timeStyle = "short"), new Intl.DateTimeFormat(e, o).format(a);
}
function o(e) {
	let t = /* @__PURE__ */ new Date(), n = typeof e == "string" ? new Date(e) : e, r = t.getTime() - n.getTime(), i = Math.floor(r / 6e4), o = Math.floor(i / 60), s = Math.floor(o / 24);
	return i < 1 ? "Ahora" : i < 60 ? `Hace ${i} min` : o < 24 ? `Hace ${o}h` : s < 7 ? `Hace ${s}d` : a(n, { style: "medium" });
}
var s = e, c = {
	thumb: 75,
	low: 200,
	medium: 500,
	high: 0
}, l = {
	thumb: "_75",
	low: "_200",
	medium: "_500",
	high: ""
}, u = /_(?:75|200|500)$/;
function d(e, t = "high") {
	if (!e) return "";
	if (t === "high") return e;
	let n = l[t];
	if (e.lastIndexOf(".") === -1) return e;
	let r = e.indexOf("?"), i = r === -1 ? e : e.substring(0, r), a = r === -1 ? "" : e.substring(r), o = i.lastIndexOf(".");
	if (o === -1) return e;
	let s = i.substring(0, o), c = i.substring(o);
	return u.test(s) ? `${s.replace(u, "")}${n}${c}${a}` : `${s}${n}${c}${a}`;
}
function f(e) {
	let t = e * 1.5;
	return t <= c.thumb ? "thumb" : t <= c.low ? "low" : t <= c.medium ? "medium" : "high";
}
function p(e) {
	return e.includes("/icecat/") || e.includes("icecat.biz");
}
function m(e) {
	return e.includes("/merchants/");
}
//#endregion
//#region src/utils/businessHours.ts
var h = [
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday",
	"sunday"
], g = {
	es: {
		monday: "Lun",
		tuesday: "Mar",
		wednesday: "Mié",
		thursday: "Jue",
		friday: "Vie",
		saturday: "Sáb",
		sunday: "Dom"
	},
	en: {
		monday: "Mon",
		tuesday: "Tue",
		wednesday: "Wed",
		thursday: "Thu",
		friday: "Fri",
		saturday: "Sat",
		sunday: "Sun"
	},
	pt: {
		monday: "Seg",
		tuesday: "Ter",
		wednesday: "Qua",
		thursday: "Qui",
		friday: "Sex",
		saturday: "Sáb",
		sunday: "Dom"
	},
	ru: {
		monday: "Пн",
		tuesday: "Вт",
		wednesday: "Ср",
		thursday: "Чт",
		friday: "Пт",
		saturday: "Сб",
		sunday: "Вс"
	}
};
function _(e, t) {
	return g[t.split("-")[0]]?.[e] ?? g.es[e] ?? e;
}
function v(e, t = "es") {
	let n = [];
	for (let t of h) {
		let r = e[t];
		if (!r || r.closed) continue;
		let i = `${r.open}-${r.close}`, a = n[n.length - 1];
		a && a.schedule === i ? a.days.push(t) : n.push({
			days: [t],
			schedule: i
		});
	}
	return n.length === 0 ? [] : n.map((e) => {
		let n = _(e.days[0], t), r = _(e.days[e.days.length - 1], t);
		return `${e.days.length > 1 ? `${n}-${r}` : n}: ${e.schedule}`;
	});
}
function y(e) {
	let t = /* @__PURE__ */ new Date(), n = t.getDay(), r = e[h[n === 0 ? 6 : n - 1]];
	if (!r || r.closed || !r.open || !r.close) return !1;
	let [i, a] = r.open.split(":").map(Number), [o, s] = r.close.split(":").map(Number), c = t.getHours() * 60 + t.getMinutes(), l = i * 60 + (a || 0), u = o * 60 + (s || 0);
	return c >= l && c < u;
}
//#endregion
//#region src/utils/urlParams.ts
var b = "attr_";
function x(e, t = new URLSearchParams()) {
	for (let [n, r] of Object.entries(e)) if (r != null) {
		if (typeof r == "boolean") t.set(`${b}${n}`, String(r));
		else if (Array.isArray(r)) r.length > 0 && t.set(`${b}${n}`, r.join(","));
		else if (typeof r == "object" && ("min" in r || "max" in r)) {
			let e = r;
			e.min !== null && e.min !== void 0 && t.set(`${b}${n}_min`, String(e.min)), e.max !== null && e.max !== void 0 && t.set(`${b}${n}_max`, String(e.max));
		}
	}
	return t;
}
function S(e) {
	let t = {}, n = {};
	for (let [r, i] of e.entries()) {
		if (!r.startsWith("attr_")) continue;
		if (r.endsWith("_min") || r.endsWith("_max")) {
			let e = r.endsWith("_min"), t = r.slice(5, -4);
			n[t] || (n[t] = {
				min: null,
				max: null
			});
			let a = parseFloat(i);
			isNaN(a) || (e ? n[t].min = a : n[t].max = a);
			continue;
		}
		let e = r.slice(5);
		if (i === "true") {
			t[e] = !0;
			continue;
		}
		if (i === "false") {
			t[e] = !1;
			continue;
		}
		i.includes(",") ? t[e] = i.split(",").filter(Boolean) : t[e] = [i];
	}
	for (let [e, r] of Object.entries(n)) (r.min !== null || r.max !== null) && (t[e] = r);
	return Object.keys(t).length > 0 ? t : void 0;
}
function C(e) {
	let t = new URLSearchParams(e);
	for (let e of [...t.keys()]) e.startsWith("attr_") && t.delete(e);
	return t;
}
function w(e, t, n) {
	let r = new URLSearchParams(e);
	for (let e of [...r.keys()]) (e === `attr_${t}` || e === `attr_${t}_min` || e === `attr_${t}_max`) && r.delete(e);
	if (n == null) return r;
	if (typeof n == "boolean") r.set(`${b}${t}`, String(n));
	else if (Array.isArray(n) && n.length > 0) r.set(`${b}${t}`, n.join(","));
	else if (typeof n == "object" && ("min" in n || "max" in n)) {
		let e = n;
		e.min !== null && e.min !== void 0 && r.set(`${b}${t}_min`, String(e.min)), e.max !== null && e.max !== void 0 && r.set(`${b}${t}_max`, String(e.max));
	}
	return r;
}
function T(e) {
	let t = e.get("category"), n = new URLSearchParams();
	return t && n.set("category", t), n;
}
var E = "ice_", D = "|";
function O(e) {
	let t = {};
	for (let [n, r] of e.entries()) {
		if (!n.startsWith("ice_")) continue;
		if (n.endsWith("_min") || n.endsWith("_max")) {
			let e = n.endsWith("_min"), i = n.slice(4, -4);
			t[i] || (t[i] = { range: {
				min: void 0,
				max: void 0
			} }), t[i].range || (t[i].range = {
				min: void 0,
				max: void 0
			});
			let a = parseFloat(r);
			isNaN(a) || (e ? t[i].range.min = a : t[i].range.max = a);
			continue;
		}
		let e = n.slice(4);
		r.includes("|") ? t[e] = { values: r.split("|").filter(Boolean) } : t[e] = { values: [r] };
	}
	return Object.keys(t).length > 0 ? t : void 0;
}
function k(e, t, n) {
	let r = new URLSearchParams(e);
	for (let e of [...r.keys()]) (e === `ice_${t}` || e === `ice_${t}_min` || e === `ice_${t}_max`) && r.delete(e);
	if (n == null) return r;
	if (typeof n == "boolean") r.set(`${E}${t}`, n ? "Y" : "N");
	else if (Array.isArray(n) && n.length > 0) r.set(`${E}${t}`, n.join("|"));
	else if (typeof n == "object" && ("min" in n || "max" in n)) {
		let e = n;
		e.min !== null && e.min !== void 0 && r.set(`${E}${t}_min`, String(e.min)), e.max !== null && e.max !== void 0 && r.set(`${E}${t}_max`, String(e.max));
	}
	return r;
}
//#endregion
export { i as C, r as S, m as _, C as a, n as b, x as c, v as d, y as f, p as g, f as h, T as i, w as l, d as m, E as n, S as o, c as p, D as r, O as s, b as t, k as u, s as v, o as w, a as x, t as y };

//# sourceMappingURL=urlParams-BK4tDkg5.js.map